import { commandCenterLoansApi } from 'app/services/api';

import { catchAsyncActionError } from 'utils/action';
import { createNamedActions } from 'utils/namedActionTypesProxy';

import { CommandCenterLoadKey, markCommandCenterLoadedAction } from './loadStatus.actions';

const SKIP_FORBIDDEN_CONFIG = { skipResponseInterceptor: { forbiddenError: true } };

export const TURN_TIME_TREND_DEFAULT_WEEKS = 8;

export const COMMAND_CENTER_TURN_TIME_TREND_ACTION_TYPE = createNamedActions(
  'commandCenterTurnTimeTrend',
  {
    SET_TURN_TIME_TREND: 'SET_TURN_TIME_TREND',
  },
);

export const getCommandCenterTurnTimeTrendAction = catchAsyncActionError(
  ({ weeks = TURN_TIME_TREND_DEFAULT_WEEKS, definitionId = null } = {}) =>
    async dispatch => {
      try {
        const { data } = await commandCenterLoansApi.getTurnTimeTrend({
          weeks,
          definitionId,
          config: SKIP_FORBIDDEN_CONFIG,
        });

        dispatch({
          type: COMMAND_CENTER_TURN_TIME_TREND_ACTION_TYPE.SET_TURN_TIME_TREND,
          payload: data ?? null,
        });
      } finally {
        // In a `finally` so the slice is marked loaded even when a swallowed 403
        // (SKIP_FORBIDDEN_CONFIG) rejects — otherwise the zone skeleton never clears.
        dispatch(markCommandCenterLoadedAction(CommandCenterLoadKey.TURN_TIME_TREND));
      }
    },
);
